module.exports = __webpack_public_path__ + "img/blog-11.6cf1f2f8.webp";